module.exports = __webpack_public_path__ + "static/002-267a38478d7d119ec1637364ab848d9c.jpg";